import { useMemo } from 'react'
import Cookies from 'js-cookie'
import { useBreakpoint } from '@leroy-merlin-br/backyard-react'

export const DEVICE_TYPES = {
  DESKTOP: 'desktop',
  MOBILE_WEB: 'mobile',
  MOBILE_APP: 'app'
}

export function useDeviceType() {
  const { breakpoint } = useBreakpoint()
  const isOnMobileApp = Cookies.get('is_on_mobile_app') === 'true'

  const deviceType = useMemo(() => {
    if (isOnMobileApp) return DEVICE_TYPES.MOBILE_APP
    if (['untilKilo', 'kilo'].includes(breakpoint))
      return DEVICE_TYPES.MOBILE_WEB
    return DEVICE_TYPES.DESKTOP
  }, [isOnMobileApp, breakpoint])

  return deviceType
}
